module.exports = __webpack_public_path__ + "img/Crew-2.5871d599.png";